(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password-collection-header"]) return;
  try {
    
    if(window.location.href.includes("/products") || window.location.href.includes("/collections")) {
        let latestID = document.querySelector("#id_latest");
        if(latestID != null && latestID != undefined && latestID.innerText.toString().trim() != localStorage.getItem(document.getElementById("id_tag").innerText+"check")) {
        localStorage.setItem(document.getElementById("id_tag").innerText+"","false");
        }
    }
  
    if(window.location.href.includes("/collections") &&
    document.getElementById('id_tag') != null && localStorage.getItem(document.getElementById("id_tag").innerText+"") == "false"
    && !document.getElementById('id_tag').innerText.includes("password")){
        window.location.href = "https://www.fashionbrandcompany.com//";
    } else if(window.location.href.includes("/products") &&
      document.getElementById('id_tag') != null &&
      document.getElementById('id_tag').innerText.includes("password") &&
      localStorage.getItem(document.getElementById("id_tag").innerText+"") != "true" && window.collectionsCount < 2 ){
        window.location.href = "https://www.fashionbrandcompany.com/";
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-protected-collection-section"]) return;
  try {
    
  document.getElementById('passwordForm').addEventListener('submit', function (e) {
    e.preventDefault();
      const enteredPassword = document.querySelector('input[name="pw"]').value;
      let checkValue = document.querySelector(".password_form").dataset.element.split("_")[1];
      if (enteredPassword == checkValue) {
        localStorage.setItem(document.getElementById("id_tag").innerText+"", "true");
        localStorage.setItem(document.getElementById("id_tag").innerText+"check", enteredPassword);        
        location.reload();
      } else {
        localStorage.setItem(document.getElementById("id_tag").innerText+"", "false");
        localStorage.setItem(document.getElementById("id_tag").innerText+"check", "false");
        document.querySelector("#error-message").setAttribute("style","display:block;color: red;");
      }
    });


    if(localStorage.getItem(document.getElementById("id_tag").innerText+"") == "true") {
      document.querySelector(".password_protected").setAttribute("style","display:block;");
document.querySelectorAll("section").forEach((e)=> {
    if(!e.classList.contains("password_protected")){
         e.style.display="none";
    }
   
});      
      document.querySelector(".password_form").innerHTML="";
    } else if (localStorage.getItem(document.getElementById("id_tag").innerText+"") == "false"){
      document.querySelector(".password_protected").innerHTML="";
    }

  } catch(e) { console.error(e); }
})();
})();
